import {useParams} from "react-router";
import PageContent from "../components/Page/PageContent";

type RouteParams = {
    slug:string,
}

const Page = () => {
    const {slug} = useParams<RouteParams>();

    return (
        <PageContent slug={slug ?? ''}/>
    )
}

export default Page;
